import {Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';

/** Layout text direction (LTR / RTL). */
export enum AppLayoutDirection {
	LTR = 'ltr',
	RTL = 'rtl',
}

@Injectable({providedIn: 'root'})
export class AppLayoutDirectionService {
	private direction = AppLayoutDirection.LTR;
	private readonly direction$ = new ReplaySubject<AppLayoutDirection>(1);

	constructor() {
		this.direction$.next(this.direction);
	}

	getDirection(): AppLayoutDirection {
		return this.direction;
	}

	setDirection(direction: AppLayoutDirection): void {
		this.direction = direction;
		document.documentElement.dir = direction;
		this.direction$.next(direction);
	}

	onDirectionChange(): Observable<AppLayoutDirection> {
		return this.direction$.asObservable();
	}
}
